import React from 'react';

const Subjects = () => {
  return <div>Subjects Page</div>;
};

export default Subjects;
